// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const VulnerableFunctionOffIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon
      data-iconname="VulnerableFunctionOffIcon"
      ref={forwardedRef}
      {...props}
    >
      <path d="M9.007 13.986a1.25 1.25 0 1 0 .225-.225z" />
      <path d="M10.992 12h.004v-.003z" />
      <path d="m14.936 8.057 1.06-1.06L19 10l-4.243 4.243-1.06-1.061L16.879 10z" />
      <path d="M10.996 7.754 9.614 9.136 8.996 9.754V4h2z" />
      <path d="M5.936 12.814 3.12 10l3.182-3.182-1.06-1.06L1 10l3.875 3.875z" />
      <path d="m3.25 15.5 6.364-6.364 6.364-6.364 1.06 1.06-12.726 12.73z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const VulnerableFunctionOffIcon = /* @__PURE__ */ Object.assign(
  VulnerableFunctionOffIconComponent,
  { displayName: 'VulnerableFunctionOffIcon' },
);
